module.exports = __webpack_public_path__ + "static/tickets.en-7ba3a44868b73a1aa69193c9f20f48ce.png";